import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Profile } from './Profile/Profile'
import Sidebar from './Sidebar'
import Topbar from './Topbar'
import './DashboardProfileStyles.css'

export const DashboardProfile = () => {
  const { t } = useTranslation()
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }

  return (
    <div
      className="relative flex min-h-screen w-full lg:ml-[10px] bg-cloud dark:bg-pebble"
      data-testid="container-dashboard-profile-container"
    >
      <Topbar />
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      {isSidebarOpen && (
        <div
          onClick={toggleSidebar}
          className="fixed inset-0 bg-black opacity-50 z-20"
          data-testid="nav-overlay"
        ></div>
      )}
      <div
        className={`flex-grow flex flex-col ${isSidebarOpen ? 'z-10' : ''}`}
        data-testid="container-content-wrapper"
      >
        <div
          className="flex flex-col items-center justify-center flex-grow pt-2 w-full"
          data-testid="container-content-container"
        >
          <div
            className="relative w-full lg:min-w-[1200px] lg:ml-[-230px] mx-auto"
            data-testid="container-layout-container"
          >
            <div
              className="p-7 sm:p-8 md:px-12 md:pt-1 mt-2 md:mt-8 w-full"
              data-testid="container-inner-container"
            >
              <h1
                className="text-3xl font-normal text-left ml-10 mb-8 text-black dark:text-white lg:mt-12 md:ml-[40px] mt-10"
                data-testid="container-title"
              >
                {t('dashboardProfile.title')}
              </h1>
              <div
                className="h-[calc(100vh-200px)] overflow-y-auto lg:overflow-hidden hide-scrollbar"
                data-testid="container-scrollable-container"
              >
                <Profile />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DashboardProfile

/*
POTENTIAL IMPROVEMENTS:
1. Consider implementing a responsive design that works better on mobile devices
2. Add proper loading states for profile data
3. Implement error handling for failed profile data fetching
4. Consider adding breadcrumbs for better navigation
5. Add proper keyboard navigation throughout the profile sections
6. Consider adding tabs for different profile sections rather than a single scrollable container
7. Improve the scrolling experience by preserving scroll position between navigations
8. Add proper aria attributes for better screen reader support
9. Consider adding a profile completeness indicator
10. Implement proper form validation for any editable profile sections
*/
